import { useState, useMemo } from "react";
import { parse, isBefore, isAfter, startOfDay, endOfDay } from "date-fns";
import styles from './index.module.scss'
import { BookingContext } from "./context";
import TicketVariation from "./TicketVariation";

import SearchableSelect from "./SearchableSelect";
import FieldInput from './TicketRow/Field/FieldInput'
//import Select from 'react-select'


export default function BookingForm({ productId }) {

    const [event, setEvent] = useState(null)
    const [expanded, setExpanded] = useState(null)

    const [customer, setCustomer] = useState(window.booking_user)

    const selectCustomer = (val) => {
        if ( ! event.admin || ! event.admin.users ) return
        let user = event.admin.users.find(user => parseInt(user.id) === parseInt(val))
        setCustomer(user)
    }

    useMemo(() => {

        console.log(`product ID changed to ${productId}`)
        const data = new FormData();

        data.append( 'action', 'get_event_json' );
        data.append( 'product_id', productId);

        fetch(ajaxObj.ajax_url, {
            method: "POST",
            body: data,
            headers: {
                'accept': 'application/json',
            }
        })   
        .then((response) => response.json())
        .then((eventData) => {
            console.log("Event response");
            console.log(eventData)
            setEvent({ ...eventData })
        })
        .catch((error) => {
            console.log("That's an error!");
            console.log(error);
        });


    }, [productId])

    /*useEffect(() => {
        console.log("Setting event var to the following");
        console.log(event)
    }, [event])*/

    if ( ! event ) {
        return (
            <div className={styles.loading}>Loading booking form...</div>
        )
    }

    let variations = event.variations.filter((variation) => {
        if ( customer && customer.roles ) {
            let isFreeVariation = variation.attributes['attribute_ticket-type'] === 'Financial Institutions'
            if ( isFreeVariation && customer.roles.includes('customer_vendor') ) return false
            if ( ! isFreeVariation && (customer.roles.includes('customer_free') || customer.roles.includes('customer_free_pending')) ) return false
        }

        return true
    })

    let currentDate = startOfDay(new Date())
    variations = variations.filter((variation) => {
        let start = variation.available_start_date ? parse(variation.available_start_date, 'yyyy-MM-dd', startOfDay(new Date())) : null
        let end = variation.available_end_date ? parse(variation.available_end_date, 'yyyy-MM-dd', endOfDay(new Date())) : null
        if (start && isBefore(currentDate, start)) return false
        if (end && isAfter(currentDate, end)) return false
        return true
    })
    
    const options = [
        { value: 1, label: "Graspus graspus" },
        { value: 2, label: "deede graspus" }
    ]
      
    return (
        <BookingContext.Provider value={{ customer }}>
            <div className={styles.inner}>
                <div className={styles.header}>
                    <h2 className={styles.title}>{event.title}</h2>
                    <div className={styles.location}>{event.location}</div>
                    <div className={styles.date}>{`${event.date} ${event.start_time} - ${event.end_time}`}</div>
                </div>

                <form method="POST" action="/">
                    <input type="hidden" name="wc" value="1" />
                    <input type="hidden" name="product_id" value={productId} />

                    {event.admin ? (
                        <>
                            <div className={styles.admin}>
                                <label className={styles.label}>[Admin] Assign Customer</label>
                                {/*<select name="customer" className={styles.control} onChange={(e) => selectCustomer(e.target.value)}>
                                    <option value="">Please select</option>
                                    {event.admin.users && event.admin.users.map(user => (<option value={user.id}>{user.first_name} {user.last_name} ({user.email})</option>))}
                                </select>

                                <Select 
                                    options={event.admin.users ? event.admin.users.map(user => ({ value: user.id, label: `${user.first_name} ${user.last_name} (${user.email})` })) : []} 
                                    className={styles.customer} 
                                    isSearchable={true} 
                                    name="customer" 
                                    onChange={(e) => selectCustomer(e.value)}
                                />*/}


                                <SearchableSelect 
                                    options={event.admin.users ? event.admin.users.map(user => ({ value: user.id, label: `${user.first_name} ${user.last_name} (${user.email})` })) : []} 
                                    handleChange={(e) => selectCustomer(e.value)} 
                                />
                                {/*<SearchableSelect 
                                    options={event.admin.users ? event.admin.users.map(user => ({ value: user.id, label: `${user.first_name} ${user.last_name} (${user.email})` })) : []} 
                                    onChange={(e) => selectCustomer(e.value)} 
                                />*/}

                                {(!customer || (window.booking_user.id === customer.id)) && (
                                    <div className={styles.create}>
                                        <FieldInput name="customer_email" field={{ label: "New customer email" }} />
                                        <FieldInput name="customer_password" field={{ label: "New customer password" }} />
                                    </div>
                                )}
                            </div>
                        </>
                    ) : <></>}

                    <div className={styles.variations}>
                        {variations.map((variation) => (
                            <TicketVariation 
                                onExpand={() => setExpanded(variation.variation_id)} 
                                expanded={expanded === variation.variation_id || variations.length === 1} 
                                variation={variation} 
                                fields={event.fields}
                            />
                        ))}
                    </div>
                </form>
            </div>
        </BookingContext.Provider>
    )


}